import { atom } from 'recoil';
import { User } from './UsersState';

const authState = atom<User>({
  key: 'auth',
  // get initial state from local storage to enable user to stay logged in
  default: JSON.parse(localStorage.getItem('user') || '{}'),
});

export { authState };
